import React, { useEffect, useRef, useState } from "react";
import driver from "../../../../assets/images/company-image.jpg";

const Driver = () => {
  const list = [
    { description: "Verified job requests only" },
    { description: "Flexible hours and routes" },
    { description: "Competitive, transparent payments" },
    { description: "Private and corporate clients" },
  ];

  const maxHeight = window.innerHeight;
  const sectionRef = useRef(null);
  const [fontScale, setFontScale] = useState(1);
  const [isFixed, setIsFixed] = useState(false);
  const [startScroll, setStartScroll] = useState(0);
  const [borderRadius, setBorderRadius] = useState(0);

  useEffect(() => {
    if (sectionRef.current) {
      setStartScroll(sectionRef.current.offsetTop);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      if (scrollY >= startScroll && scrollY <= startScroll + maxHeight) {
        setIsFixed(true);
        const scrolled = scrollY - startScroll;
        const shrinkRatio = Math.max((maxHeight - scrolled) / maxHeight, 0);

        setFontScale(shrinkRatio);
        setBorderRadius(120 * (1 - shrinkRatio));
      } else if (scrollY < startScroll) {
        setIsFixed(false);
        setFontScale(1);
        setBorderRadius(0);
      } else {
        setIsFixed(true);
        setFontScale(0);
        setBorderRadius(120);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [startScroll]);

  return (
    <>
      {window.innerWidth > 1024 ? (
        <>
          {/* Spacer to prevent layout jump */}
          <div
            className="place-holder-div"
            style={{
              height: isFixed ? `${maxHeight}px` : "auto",
            }}
          />
          <div
            ref={sectionRef}
            style={{
              height: `${maxHeight}px`,
              width: "100%",
              background: "#fff",
              borderRadius: `${borderRadius}px`,
              position: isFixed ? "fixed" : "relative",
              top: 0,
              left: 0,
              transform: `scale(${fontScale})`,
              transformOrigin: "top right",
              zIndex: 1000,
            }}
          >
            <DriverContent list={list} borderRadius={borderRadius} />
          </div>
        </>
      ) : (
        <DriverContent list={list} />
      )}
    </>
  );
};

const DriverContent = ({ list, borderRadius }) => {
  return (
    <div
      className="driver-container"
      style={{
        height: "94%",
        borderRadius: borderRadius,
        width: "auto",
        padding: "0px 60px 60px 60px",
      }}
    >
      <div className="image-container">
        <img
          className="driver-image"
          src={driver}
          alt="Driver"
          style={{
            maxWidth: "70%",
          }}
        />
      </div>
      <div className="container-description" style={{ fontSize: "0.9rem" }}>
        <div className="driver-heading" style={{ fontSize: "2rem" }}>
          <span>For Drivers: Connect Directly, Work Confidently, Get Paid Fairly</span>
        </div>
        <div className="driver-description" style={{ fontSize: "1.2rem" }}>
          <span>
            Finding good jobs that pay fairly isn’t always easy. ZOWO connects you with clients looking for your services. You pick your hours and routes, negotiate fair prices directly, and connect with private and corporate clients all over Saudi Arabia. Plus, you receive transparent and competitive payments every time.
          </span>
        </div>
        <div className="driver-list">
          {list.map((item, index) => (
            <div
              key={index}
              className="list-item-driver"
              style={{ fontSize: "0.85rem" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={30}
                height={10}
                viewBox="0 0 43 14"
                fill="none"
              >
                <path
                  d="M42.6762 5.86504L31.6524 1.36381L33.2661 13.1613L42.6762 5.86504ZM1.08411 1.05273L0.659674 1.99255C6.54595 4.65087 19.8798 8.80063 33.5313 8.15267L33.4824 7.12262L33.4335 6.09257C20.1897 6.72118 7.18342 2.67577 1.50854 0.11292L1.08411 1.05273Z"
                  fill="var(--text-white-color)"
                />
              </svg>
              <span>{item.description}</span>
            </div>
          ))}
        </div>
        <button className="ride-with-us" style={{ fontSize: "0.9rem" }}>
          Join as a Driver
        </button>
      </div>
    </div>
  );
};

export default Driver;
